import PropTypes from 'prop-types';
import React from 'react';


const StepSelectionTooltip = (props) => {

    return (
        <div {...props} className="step-selection__tooltip">
            {props.label}
        </div>
    )

}

StepSelectionTooltip.propTypes = {
    label: PropTypes.string.isRequired
}

export default StepSelectionTooltip


/** WEBPACK FOOTER **
 ** ./src/components/navigation/StepSelectionTooltip.js
 **/